/**
 * Map Scroll
 */
const map = () => {
  const $map = document.querySelector('.js-map')
  if ($map) {
    const windowWidth = $map.clientWidth
    // alert(windowWidth)
    const mapWidth = document.querySelector('.js-map > div').clientWidth
    // alert(mapWidth)
    const scrollOffset = mapWidth / 2 - windowWidth / 2
    // alert(scrollOffset)
    $map.scrollTo(scrollOffset, 0);
  }
}

export { map };
